import Pagenation from "components/Pagenation";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as dbmsApi from "../../apis/DbmsApi";
import { apiWrapper } from "apis/CommonApi";
import { dateFormat, getDateTime } from "utils/date";

//소방대상물 관리
export default function FireProtectionTargetManagementComponent() {
  const itemsPerPage = 100;
  const [isDelModalOpen, setIsDelModalOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [previous, setPrevious] = useState(null);
  const [next, setNext] = useState(null);
  const [page, setPage] = useState(1);
  const [checkedIds, setCheckedIds] = useState([]);

  useEffect(() => {
    getData(1);
  }, []);

  //page: 1베이스
  const getData = (page, url = null) => {
    apiWrapper(async () => {
      let result;
      if (url !== null) {
        result = await dbmsApi.getFireFightingObjectListByUrl(url);
      } else {
        result = await dbmsApi.getFireFightingObjectList(
          searchText,
          page,
          itemsPerPage
        );
      }

      const { status, data } = result;
      if (status === true) {
        setDataSource(data);

        setPrevious(data.previous);
        setNext(data.next);
        setPage(page);
      } else {
        alert(`${data}`);
      }
    });
  };

  const handleChangeSearchText = (e) => {
    setSearchText(e.target.value);
  }

  const handleSearch = (e) => {
    if (e.type === "click" || (e.type === "keydown" && e.keyCode === 13)) {
      getData(page);
    }
  }

  const handleExportExcel = () => {
    apiWrapper(async () => {
      const { status, data } = await dbmsApi.downloadExcelFireFightingObjectList(searchText);
      if (status === false) {
        alert(`엑셀 저장에 실패하였습니다.\n${data}`);
      }
    });
  }

  const handleCheckAll = (e) => {
    if (e.target.checked) {
      setCheckedIds(dataSource.results.map((a) => a.id));
    } else {
      setCheckedIds([]);
    }
  };

  const handleChangeCheck = (e, id) => {
    if (e.target.checked) {
      setCheckedIds([...checkedIds, id]);
    } else {
      setCheckedIds(checkedIds.filter((a) => a !== id));
    }
  };

  const handleDelete = () => {
    apiWrapper(async () => {
      const { status, data } = await dbmsApi.bulkDeleteFireFightingObject(checkedIds);
      alert(`${data}`)

      //삭제 성공 시 새로고침
      if (status === true) {
        getData(page);
        closeDelModal();
      }
    });
  }

  const openDelModal = () => {
    if (checkedIds.length < 1) {
      alert("1개 이상 선택해주세요.");
    } else {
      setIsDelModalOpen(true);
    }
  }

  const closeDelModal = () => {
    setIsDelModalOpen(false);
  }

  const handlePageArrowClick = (page, isNext) => {
    let url = null;
    if (isNext === false) {
      url = previous;
    } else {
      url = next;
    }

    getData(page, url);
  }

  return (
    <>
      <div class="viewBoard viewDBMSBoard FFMBoard">
        <div class="top_board pc">
          <p class="title_board">소방대상물 관리</p>
          <div class="wrap_search openSearch">
            <div class="box_search">
              <div class="select_box">
                <button class="btn_select">
                  <p>소방대상물명</p>
                </button>
              </div>
              <input class="" type="text" placeholder="검색어를 입력해주세요." onChange={handleChangeSearchText} onKeyDown={handleSearch} defaultValue={searchText} />
              <button class="btn_search" onClick={handleSearch}>
                <i class="x-icon icon_search"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="top_board mb">
          <div class="wrap_logo">
            {/* <!-- <img src="" alt="" class="img_logo"> --> */}
          </div>
          <div class="header_dept">
            <p class="user">COWORKER</p>
            <div class="wrap_contr">
              <Link class="set_contr" to="">
                {/* <img src="/images/my_btn_mb.png" alt=""> */}
              </Link>
            </div>
          </div>
        </div>
        <div class="top_board navi_board mb">
          <Link class="wrap_navi" to="/">
            <p class="title_navi">소방대상물 관리</p>
          </Link>

          <div class="wrap_right mb">
            <Link class="btn_page_left" to="/dbmsMenu.html">
              <i class="x-icon"></i>
            </Link>
          </div>
        </div>

        <div class="table_board ">
          <table class="admin-table uam-table">
            <colgroup>
              <col width="4%" />
              <col width="4%" />
              <col width="6%" />
              <col width="10%" />
              <col width="4%" />
              <col width="4%" />
              <col width="4%" />
              <col width="4%" />
              <col width="4%" />
              <col width="4%" />
              <col width="4%" />
              <col width="4%" />
              <col width="7%" />
              <col width="7%" />
              <col width="4%" />
              <col width="8%" />
              <col width="8%" />
            </colgroup>
            <thead class="admin-thead">
              <tr class="admin-tr">
                <th class="admin-th">
                  <input type="checkbox" name="" id="" onChange={handleCheckAll} />
                </th>
                <th class="admin-th">
                  관리ID
                </th>
                <th class="admin-th">
                  건물명칭
                </th>
                <th class="admin-th">
                  도로명주소
                </th>
                <th class="admin-th">
                  건물층수(지상)
                </th>
                <th class="admin-th">
                  건물층수(지하)
                </th>
                <th class="admin-th">
                  건축면적
                </th>
                <th class="admin-th">
                  연면적
                </th>
                <th class="admin-th">
                  용적률
                </th>
                <th class="admin-th">
                  주용도
                </th>
                <th class="admin-th">
                  주구조
                </th>
                <th class="admin-th">
                  지붕
                </th>
                <th class="admin-th">
                  준공일
                </th>
                <th class="admin-th">
                  사용승인일
                </th>
                <th class="admin-th">
                  사업자
                </th>
                <th class="admin-th">
                  최초 등록 일시
                </th>
                <th class="admin-th">
                  최종 수정 일시
                </th>
              </tr>
            </thead>
            <tbody class="admin-tbody">
              {dataSource.results &&
                dataSource.results.map((item, index) => (
                  <tr class="admin-tr">
                    <td class="admin-td">
                      <input type="checkbox" name="" id="" checked={checkedIds.includes(item.id)} onChange={(e) => handleChangeCheck(e, item.id)} />
                    </td>
                    <td class="admin-td">
                      {item.id}
                    </td>
                    <td class="admin-td">
                      {item.buildingName}
                    </td>
                    <td class="admin-td">
                      {item.roadAddress}
                    </td>
                    <td class="admin-td">
                      {item.groundFloors}
                    </td>
                    <td class="admin-td">
                      {item.basementFloors}
                    </td>
                    <td class="admin-td">
                      {item.buildingArea}
                    </td>
                    <td class="admin-td">
                      {item.totalFloorArea}
                    </td>
                    <td class="admin-td">
                      {item.floorAreaRatio}
                    </td>
                    <td class="admin-td">
                      {item.mainUse}
                    </td>
                    <td class="admin-td">
                      {item.mainStructure}
                    </td>
                    <td class="admin-td">
                      {item.roofStructure}
                    </td>
                    <td class="admin-td">
                      {dateFormat(new Date(item.completionDate))}
                    </td>
                    <td class="admin-td">
                      {dateFormat(new Date(item.approvalDate))}
                    </td>
                    <td class="admin-td">
                      {item.businessName}
                    </td>
                    <td class="admin-td">
                      {getDateTime(new Date(item.createAt))}
                    </td>
                    <td class="admin-td">
                      {getDateTime(new Date(item.updateAt))}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        <div class="wrap_controll type-start">
          <div class="wrap_dbms_btn">
            <button class="item_btn" onClick={handleExportExcel}>엑셀</button>
            <button class="item_btn" id="deleteBtn" onClick={openDelModal}>삭제</button>
          </div>
          <div id="pagination">
            <Pagenation
              totalItemsCount={dataSource.count}
              itemsPerPage={itemsPerPage}
              selectedPage={page}
              setPage={(value) => setPage(value)}
              handlePageArrowClick={handlePageArrowClick}
            />
          </div>
        </div>

        {/* <!-- 삭제 여부 모달 --> */}
        {isDelModalOpen && (
          <div id="modal" class="modal dbmsDelModal show">
            <div class="modal-content">
              <div class="modal_inner">
                <p class="modal_title">정말로 삭제하시겠습니까?</p>
                <p class="modal_sub">삭제하시면 선택하신 정보는 사라집니다.</p>
                <div class="btn-wrap">
                  <button class="modal_btn" onClick={closeDelModal}>취소</button>
                  <button class="modal_btn del_btn" onClick={handleDelete}>삭제</button>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </>
  );
}
